import React from "react";

import type { NewSubscription } from "@app/analytics/account/Billing/types";
import * as Events from "@app/analytics/tracking/events";
import ROUTES from "@app/common/routes";
import { withQueryParamsUrl } from "@app/common/utils";
import useWorkspace from "@app/common/workspaces/useWorkspace";
import Config from "@app/config";
import { getAppUrl } from "@app/utils/utils";

import BillingPurchaseForm, {
  BillingPurchaseFormProps,
} from "../BillingPurchaseForm";

type BillingSubscriptionCheckoutPurchaseProps = Omit<
  BillingPurchaseFormProps,
  "onPurchase" | "paymentConfirmReturnUrl" | "submitCta"
> & { subscription: NewSubscription };

const BillingSubscriptionCheckoutPurchase = ({
  subscription,
  ...props
}: BillingSubscriptionCheckoutPurchaseProps) => {
  const { inWorkspace } = useWorkspace();

  const handlePurchase = () => {
    Events.purchasePlan({
      seats: subscription.quantity,
      plan: subscription.plan,
      cadence: subscription.cadence,
    });
  };

  // if the user is purchasing more than one license, and they are not already in a workspace,
  // a successful subscription purchase should land them on the "Create a Workspace" page.
  // otherwise, just put them back on the billing page
  const successRoute =
    !inWorkspace && subscription.quantity > 1
      ? ROUTES.NEW_WORKSPACE
      : ROUTES.BILLING;

  const paymentConfirmReturnUrl = withQueryParamsUrl(
    Config.stripe.subscriptionCheckoutReturnUrl,
    {
      ...subscription,
      confirm_type: props.paymentInfoElementOptions?.type,
      redirect_to: withQueryParamsUrl(
        getAppUrl(successRoute, { app: "main" }),
        { from: "subscription_purchase" }
      ),
      error_redirect_to: withQueryParamsUrl(
        getAppUrl(ROUTES.BILLING, { app: "main" }),
        { from: "subscription_purchase" }
      ),
    }
  );

  return (
    <BillingPurchaseForm
      onPurchase={handlePurchase}
      paymentConfirmReturnUrl={paymentConfirmReturnUrl}
      submitCta="Subscribe"
      {...props}
    />
  );
};

export default BillingSubscriptionCheckoutPurchase;
